import cloneDeep from 'lodash/cloneDeep';
import * as api from '../resources/widgets.api';
import actionTypes from './action-types';

export const addWidget = (widget) => ({
  type: actionTypes.ADD_WIDGET,
  widget,
});

export const updateWidget = (index, widget) => ({
  type: actionTypes.UPDATE_WIDGET,
  index,
  widget,
});

export const deleteWidget = (index) => ({
  type: actionTypes.DELETE_WIDGET,
  index,
});

export const cancelWidgetsChanges = () => async (dispatch, getState) => {
  const { widgets } = getState();
  const { items } = widgets;
  const copyItems = cloneDeep(items);
  dispatch({
    type: actionTypes.CANCEL_WIDGETS_CHANGES,
    copyItems,
  });
};

export const fetchWidgetsRequest = () => ({
  type: actionTypes.FETCH_WIDGETS_REQUEST,
  name: 'widgetsLoadingStatus',
});

export const fetchWidgetsSuccess = (home, { draft, items }) => ({
  type: actionTypes.FETCH_WIDGETS_SUCCESS,
  home,
  draft,
  items,
  name: 'widgetsLoadingStatus',
});

export const fetchWidgetsFailure = () => ({
  type: actionTypes.FETCH_WIDGETS_FAILURE,
  name: 'widgetsLoadingStatus',
});

export const fetchWidgets =
  (home = false) =>
  async (dispatch, getState) => {
    try {
      const { config } = getState();
      const { jurisdictionId, secondHandApproval } = config;
      const showOnlyPublishedWidgets = home || !secondHandApproval;
      const params = {
        showOnlyPublishedWidgets,
        jurisdictionId,
      };

      dispatch(fetchWidgetsRequest());
      const result = await api.fetchWidgets(params);
      dispatch(fetchWidgetsSuccess(home, result));
    } catch (error) {
      dispatch(fetchWidgetsFailure());
      // eslint-disable-next-line no-console
      console.error('FETCH_WIDGETS', error);
    }
  };



// WEBPACK FOOTER //
// ./src/modules/app/actions/widgets.actions.js